const DAY_MS = 24 * 60 * 60 * 1000;

export const DOC_LABELS = {
  rc_book: "RC",
  insurance: "Insurance",
  puc: "PUC",
  permit: "Permit",
};

export function parseDateOnly(dateStr) {
  if (!dateStr) return null;
  const parts = String(dateStr).slice(0, 10).split("-");
  if (parts.length !== 3) return null;
  const [y, m, d] = parts.map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function getRemainingDays(expiryDateStr, now = new Date()) {
  const expiry = parseDateOnly(expiryDateStr);
  if (!expiry) return null;
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((expiry - today) / DAY_MS);
}

export function checkDocumentExpiry(document) {
  const docKey = document.doc_key;
  const label = document.label || DOC_LABELS[docKey] || docKey;
  const days = getRemainingDays(document.expiry_date);

  if (days === null || days > 15) return null;
  if (days > 7)
    return { status: "warning", doc_key: docKey, label, days, message: `⚠️ ${label} expires in ${days} days.` };
  if (days > 1)
    return { status: "urgent", doc_key: docKey, label, days, message: `🚨 ${label} expires in ${days} days.` };
  if (days === 1)
    return { status: "urgent", doc_key: docKey, label, days, message: `🚨 ${label} expires tomorrow.` };
  if (days === 0)
    return { status: "today", doc_key: docKey, label, days, message: `❌ ${label} expires today.` };
  return { status: "expired", doc_key: docKey, label, days, message: `❌ ${label} has expired.` };
}

export function checkVehicleDocumentExpiry(documents) {
  if (!Array.isArray(documents)) return [];
  return documents.map(checkDocumentExpiry).filter(Boolean);
}